import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useProperty } from '@eti/providers';
import { BoundNew } from '@eti/types';
import { date } from '@eti/utils';
import { addDays } from 'date-fns';

const datePattern = 'yyyy-MM-dd';

const BookingComWidget = ({ bounds }) => {
  const { p } = useProperty();
  const bookingComWidgetId = p('IbeClient.Order.UpsellBookingCOM.DataHash');

  const [outBound, ...rest] = bounds;
  const inBound = rest.pop();

  const lastSegmentInList = outBound.segments.length - 1;
  const { arrivedAt: arrivedAtDate, destination } = outBound.segments[lastSegmentInList];
  const checkInDate = date.format(arrivedAtDate, datePattern);

  const { code } = destination;

  const { departuredAt } = inBound?.segments?.[0] ?? '';
  const checkOutDate = inBound
    ? date.format(departuredAt, datePattern)
    : date.format(addDays(new Date(arrivedAtDate), 7), datePattern);

  useEffect(() => {
    let bookingComScript = document.getElementById('sp_widget');
    if (!bookingComScript) {
      bookingComScript = document.createElement('script');
    }

    bookingComScript.setAttribute('type', 'text/javascript');
    bookingComScript.setAttribute('id', 'sp_widget');
    bookingComScript.setAttribute('data-hash', bookingComWidgetId);
    bookingComScript.setAttribute('data-container', 'b_container');
    bookingComScript.setAttribute('data-size', '100%x500');
    bookingComScript.setAttribute('data-tpncy', 'false');
    bookingComScript.setAttribute('data-testid', 'upsell-booking-com-script');
    bookingComScript.setAttribute(
      'src',
      `https://aff.bstatic.com/static/affiliate_base/js/booking_sp_widget.js?checkin=${checkInDate}&checkout=${checkOutDate}&iata_orr=1&iata=${code}`,
    );

    document.body.appendChild(bookingComScript);
    return () => {
      if (document.getElementById('sp_widget')) {
        document.body.removeChild(bookingComScript);
      }
    };
  }, [bookingComWidgetId, checkOutDate, code, checkInDate]);

  return <div data-testid="upsell-booking-com-widget" id="b_container" />;
};

BookingComWidget.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
};

export default BookingComWidget;
